//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { CommunityRoomsLargeSVG } from './svg'

interface CommunityRoomsLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const CommunityRoomsLargeIcon: React.FC<CommunityRoomsLargeIconProps> = forwardRef<
  CommunityRoomsLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon ref={ref} boxSize={boxSize} as={CommunityRoomsLargeSVG} sx={sx} />
))
